import { Loading } from "@/components/ui/loading";

interface LoadingStateProps { }

export function LoadingState({ }: LoadingStateProps) {
  return (
    <div className="p-4">
      <Loading messageKey="knowledgeBase.loading" minHeight="min-h-[200px]" />
    </div>
  );
}